let resource = 'reports'

export default ($axios, isAdmin = false) => ({
	getReports(params = {}) {
		return $axios.get(`/${isAdmin ? 'superAdmin/searchReports' : resource}`, {
			params
		})
	},

	getVenueReports(venueId, params = {}) {
		return $axios.get(`/venues/${venueId}/${resource}`, {
			params
		})
	},

	getPartnerSavedReports(partnerId, params = {}) {
		return $axios.get(`/partners/${partnerId}/savedReports`, {
			params
		})
	},

	getVenueSavedReports(venueId, params = {}) {
		return $axios.get(`/venues/${venueId}/savedReports`, {
			params
		})
	},

	runReport(reportId, params = {}) {
		let url = `${isAdmin ? '/superAdmin' : ''}/${resource}/run/${reportId}`
		if (params.functionName) {
			url += '/' + params.functionName
			delete params.functionName
		}
		return $axios.get(url, {params})
	},

	runVenueReport(reportId, venueId, params = {}) {
		let url = `/${resource}/run/${reportId}/venue/${venueId}`
		if (params.functionName) {
			url += '/' + params.functionName
			delete params.functionName
		}
		return $axios.get(url, {params})
	},


	exportReport(reportId, params = {}) {
		let url = `${isAdmin ? '/superAdmin' : ''}/${resource}/export/${reportId}`
		if (params.functionName) {
			url += '/' + params.functionName
			delete params.functionName
		}

		return $axios.get(url, {params})
	},

	exportVenueReport(reportId, venueId, params = {}) {
		let url = `/${resource}/export/${reportId}/venue/${venueId}`
		if (params.functionName) {
			url += '/' + params.functionName
			delete params.functionName
		}

		return $axios.get(url, {params})
	},

	getConstants(params = {}) {
		return $axios.get(`/${resource}/constants`, {
			params
		})
	},

	setExportByMail(reportExportId, params = {}) {
		return $axios.put(`/${resource}/setExportByMail/${reportExportId}`, {
			params
		})
	},

	computeDraftReports(params = {}) {
		return $axios.post('/superAdmin/reports/drafts', {
			params
		})
	},

	approveDraftReports(exportLogId, params = {}) {
		return $axios.post(`/superAdmin/reports/draft/${exportLogId}/approve`, {
			params
		})
	}

})
